import React, { useState } from 'react'

export default function ExperimentalData() {
    const [sel, setSel] = useState()
    const MENU = [
        {
            menu: 'Patient',
            options: [{
                option: 'Admission'
            }, {
                option: 'Discharges'
            }]
        },
        {
            menu: 'Correlations',
            options: []
        }
    ]
    return (
        <div>
            <div>
                <div className='d-flex'>
                    {MENU.map(m => <button key={m.menu} onClick={() => setSel(m)} className={`btn ${sel && sel.menu == m.menu ? 'bg-primary-container' : ''}`}>{m.menu}</button>)}
                </div>
                <div className='d-flex'>
                    {sel && sel.options.map(o => <button className='btn'>{o.option}</button>)}
                </div>
            </div>
            <div className='d-flex'>
                <div className='flex-grow-1'>
                    Work Area
                </div>
                <div>
                    Properties
                </div>
            </div>
        </div>
    )
}
